<template>
	<PaymentProgressStatusBox :status-code="status.code"
							  :status-tooltip="status.name"
	/>
</template>

<script>
import PaymentProgressStatusBox from "@/components/templates/common/payments/PaymentProgressStatusBox";
import {paymentProgress} from "@/common/utils/paymentProgress";

export default {
	components: { PaymentProgressStatusBox },
	computed: {
		status() {
			let data = this.params.data;

			return paymentProgress.getStatusForSettlement(
				data.dueDate,
				data.seller2BuyerPaymentStatus,
				data.seller2BuyerAmountAlreadyPaid,
				data.seller2BuyerAmountRequested,
				data.seller2BuyerAmountExpected
			);
		}
	}
};
</script>